import adviceApp from "../assets/AdviceApp1024.png";
import kenzieHubApp from "../assets/KenzieHub1024.png";
import kenzieBurguer from "../assets/KenzieBurguer1024.png";
import onTrip from "../assets/OnTrip1024.png";

export const projects = [
    {
        image: adviceApp,
        title: "Gerador de Conselhos",
        description: "O projeto consiste em um gerador de conselhos. O grande desafio é consumir os dados da API Advice Slip e gerar um novo conselho a cada clique do usuário no botão.",
        id: 1,
        url: "https://new-advice-generator-app.vercel.app/",
        repositorie: "https://github.com/brunopassos/advice-app",
        techStack: ["HTML", "CSS", "JavaScript", "React", "API"]
    },
    {
        image: kenzieHubApp,
        title: "Kenzie Hub",
        description: "O KenzieHub é uma plataforma para gerenciar a evolução das habilidades em tecnologias, o usuário pode adicionar, editar e remover tecnologias aprendidas e que estão em desenvolvimento.",
        id: 2,
        url: "https://kenziehub-brunopassos.vercel.app/",
        repositorie: "https://github.com/brunopassos/KenzieHub",
        techStack: ["HTML", "CSS", "JavaScript", "React", "API", "Yup", "Toastfy", "router-DOM"]
    },
    {
        image: onTrip,
        title: "OnTrip",
        description: "O OnTrip é uma plataforma para reserva de acomodações focada em nômades digitais. As acomodações devem possuír uma infraestrutura básica como ótimo acesso a internet e local para trabalho.",
        id: 3,
        url: "https://ontrip.vercel.app/",
        repositorie: "https://github.com/brunopassos/Capstone-m3",
        techStack: ["ReactJs" , "Material UI" , "Redux" , "Styled-components" , "Yup" , "react-router-dom" , "Hook-form" , "Axios" , "Dropzone-ui" ]
    },
    {
        image: kenzieBurguer,
        title: "Kenzie Burguer",
        description: "Aplicação baseada em um e-commerce de lanches. No Kenzie Burgue você pode adicionar os produtos no carrinho, filtrar pelo nome, adicionar mais de um item e alterar o carrinho.",
        id: 4,
        url: "https://hamburgueria-kenzie-brunopassos.vercel.app/",
        repositorie: "https://github.com/brunopassos/KenzieBurguer",
        techStack: ["HTML", "CSS", "JavaScript", "React", "API"]
    },
]


